import {
  useGetGiftingPageAndAccountById,
  useGetVssPlanById
} from '@portal-middleware/hooks';
import { useGetSessionInfo } from '@sentinel/hooks';
import { useWizard } from '@vestwell-frontend/ui';

import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { CreateGiftState } from '../config';

export const useGiftState = (isPublicPage: boolean) => {
  const { planId, giftingId } = useParams();
  const ctx = useWizard<CreateGiftState>();
  const user = useGetSessionInfo('user', {
    query: {
      suspense: true,
      useErrorBoundary: !isPublicPage
    }
  });

  const [giftContributorId, setGiftContributorId] = useState<string | null>(
    null
  );

  useEffect(() => {
    const contributorId = user?.data?.giftContributorId
      ? user?.data?.giftContributorId
      : ctx?.state?.giftSubmission?.contributor?.giftContributorId
        ? ctx?.state?.giftSubmission?.contributor?.giftContributorId
        : 'null';
    setGiftContributorId(contributorId);
  }, [user, ctx?.state?.giftSubmission?.contributor?.giftContributorId]);

  const giftAndAccount = useGetGiftingPageAndAccountById(
    giftingId,
    isPublicPage ? 'null' : giftContributorId,
    {
      query: {
        suspense: true,
        useErrorBoundary: isPublicPage
      }
    }
  );

  const plan = useGetVssPlanById(
    giftAndAccount?.data?.data?.giftAccount?.planId || planId,
    {
      query: {
        suspense: true
      }
    }
  );

  const clearSessionIfNotLoggedIn = useCallback(() => {
    if (
      !user?.data?.userId &&
      ctx?.state?.giftSubmission?.contributor?.giftContributorId &&
      !ctx?.state?.isAuthenticated
    ) {
      ctx.resetState();
    }
  }, [ctx?.state?.giftSubmission?.contributor?.giftContributorId, user]);

  return {
    clearSessionIfNotLoggedIn,
    ctx,
    giftAndAccount,
    giftContributorId,
    isPublicPage,
    plan,
    setGiftContributorId,
    user
  };
};
